<script>
import "@/assets/styles/kms-public.scss";
import axios from "axios";

export default {
  name: "KmsPublicIndex",
  data() {
    return {
      videos: [],
      loading: true,
      search: "",
    };
  },
  mounted() {
    this.fetchVideos();
  },
  methods: {
    fetchVideos() {
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            "kms/public/videos"
        )
        .then((res) => {
          this.videos = res.data.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    filteredVideos() {
      return this.videos.filter((v) =>
        v.title.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
};
</script>

<template>
  <div class="kms-public">
    <!-- HEADER -->
    <header class="kms-header">
      <div class="kms-header-left">
        <h5>🎓 Video Pembelajaran</h5>
      </div>

      <div class="kms-header-center">
        <input
          v-model="search"
          type="text"
          class="kms-search"
          placeholder="Cari video pembelajaran..."
        />
      </div>

      <div class="kms-header-right">
        <router-link to="/login" class="kms-login-btn">
          Login
        </router-link>
      </div>
    </header>

    <!-- CONTENT -->
    <main class="kms-content">
      <div v-if="loading" class="kms-loading">
        <i class="fas fa-spinner fa-spin"></i> Memuat video...
      </div>

      <div v-else class="kms-video-grid">
        <div
          v-for="video in filteredVideos"
          :key="video.id"
          class="kms-video-card"
          @click="$router.push(`/kms/${video.slug}`)"
        >
          <!-- Thumbnail -->
          <div class="kms-thumbnail">
            <img
              :src="video.thumbnail"
              alt="thumbnail"
            />
            <span class="kms-duration">
              {{ video.duration || "00:00" }}
            </span>
          </div>

          <!-- Info -->
          <div class="kms-video-info">
            <h6 class="kms-video-title">
              {{ video.title }}
            </h6>
            <p class="kms-video-meta">
              {{ video.category_name || "Umum" }}
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
